export default __webpack_public_path__ + "static/media/mar_lewc_seal.71931111.png";